import { Add, Delete } from "@mui/icons-material";
import { Autocomplete, Box, Button, Paper, TextField } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import { getHealersByModality } from "../services/suggested-healers";

const MODALITIES = [
  'Vaastu Healing',
  'Theta Healing',
  'Tantra',
  'Spirit Release Therapy',
  'Sound Healing',
  'Somatic & Trauma Healing',
  'Shamanism',
  'Reiki',
  'Redikall Healing',
  'Quantum Healing',
  'Psychic Readings',
  'Pranic Healing',
  'Past Life Regression (PLR)',
  'Nuero Linguistic Programming (NLP)',
  'Meditation',
  'Life Between Lives',
  'Jikiden Reiki',
  'Hypnotherapy',
  'Healing Through Prayer',
  'Healing Gems',
  'Heal Your Life',
  'Family Constellations',
  'Emotional Freedom Technique (EFT)',
  'Dowsing',
  'Carnio Sacral Therapy',
  'Chakra Balancing',
  'Aura Healing',
  'Angel Healing',
  'Tarot Card Reading',
  'Switch Words',
  'Dragon Energy',
  'Akashic Records',
];

const ModalityRow = ({
  selected_modality,
  selected_healers,
  handleChangeModality,
  handleChangeHealer,
  handleDeleteModality,
  index
}) => {

  const [all_healers, set_all_healers] = useState([]);
  const [is_fetching_data, set_is_fetching_data] = useState(false);

  const getHealersForModalities = useCallback(async () => {
    set_is_fetching_data(true);
    const { data } = await getHealersByModality({ modality: selected_modality });

    set_is_fetching_data(false);
    if (data) {
      set_all_healers(data.healers);
    }
  }, [selected_modality])

  const handleHealerChange = (event, value) => {
    const healer_ids = value.map(item => item._id);
    updateHealersValue(healer_ids);
  }

  const updateHealersValue = useCallback((value) => {
    handleChangeHealer(index, value)
  }, [index, handleChangeHealer])

  useEffect(() => {
    if (selected_modality) {
      getHealersForModalities()
    }
  }, [selected_modality, getHealersForModalities]);


  const selectedHealers = useMemo(() => {
    return all_healers.filter(healer => selected_healers.includes(healer._id))
  }, [all_healers, selected_healers])

  return (
    <Box
      component='div'
      sx={{
        padding: '16px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
      }}
    >
      <Autocomplete
        fullWidth
        options={MODALITIES}
        renderInput={(params) => <TextField {...params} label="Modality" />}
        value={selected_modality}
        onChange={(event, value) => {
          handleChangeModality(index, value)
        }}
      />

      <Autocomplete
        disabled={
          !Boolean(selected_modality) ||
          is_fetching_data
        }
        multiple
        options={all_healers}
        renderInput={(params) => <TextField {...params} label={"Healers"} />}
        getOptionLabel={(option) => option.name}
        value={selectedHealers}
        filterSelectedOptions
        onChange={handleHealerChange}
        loading={is_fetching_data}
        loadingText='Fetching Healers . . .'
      />

      <Box
        component='div'
        display='flex'
        justifyContent='flex-end'
      >
        <Button
          variant="outlined"
          size="small"
          color="error"
          onClick={() => handleDeleteModality(index)}
          startIcon={<Delete />}
        >
          Delete Modality
        </Button>
      </Box>
    </Box>
  )
}

const BLANK_MODALITY = {
  modality : '',
  healers : []
}
const MainQuestionnaireOption = ({
  option,
  handleOptionChange,
  handleDeleteOption,
  index
}) => {

  const handleAddModality = () => {
    const new_modalities = [...option.modalities, BLANK_MODALITY]
    handleOptionChange(index, 'modalities', new_modalities)
  }

  const handleChangeModality = (modality_index, value) => {
    const _modalities = [...option.modalities];
    const selected_modality = {..._modalities[modality_index]};
    selected_modality.modality = value;
    selected_modality.healers = [];
    _modalities[modality_index] = selected_modality;

    handleOptionChange(index, 'modalities', _modalities);
  }
  const handleChangeHealer = (modality_index, value) => {
    const _modalities = [...option.modalities];
    const selected_modality = {..._modalities[modality_index]};
    selected_modality.healers = value;
    _modalities[modality_index] = selected_modality;
    
    handleOptionChange(index, 'modalities', _modalities);
  }
  const handleDeleteModality = (modality_index) => {
    const _modalities = [...option.modalities];
    _modalities.splice(modality_index, 1);

    handleOptionChange(index, 'modalities', _modalities);
  }
  return (
    <Paper
      sx={{
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
      }}
    >
      <Box
        component='div'
        display='flex'
        justifyContent='flex-end'
      >
        <Button
          variant="contained"
          color="error"
          onClick={() => handleDeleteOption(index)}
          startIcon={<Delete />}
        >
          Delete Option
        </Button>
      </Box>

      <TextField
        multiline
        fullWidth
        label='Option Title'
        rows={2}
        value={option.title}
        onChange={(e) => handleOptionChange(index, 'title', e.target.value)}
      />
      <TextField
        fullWidth
        label='Option Order'
        value={option.option_order}
        onChange={(e) => handleOptionChange(index, 'option_order', e.target.value)}
      />

      <Box
        component='div'
        sx={{
          padding: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #ccc',
          borderRadius: '4px'
        }}
      >
        Modalities

        <Button
          variant="contained"
          size="small"
          onClick={handleAddModality}
        >
          Add Modality
        </Button>
      </Box>


      {
        option.modalities.map((modality, modality_index) => {
          return(
            <ModalityRow
              key={`OPTION-${index}-MODALITY-${modality_index}`}
              index = {modality_index}
              selected_healers={modality.healers}
              selected_modality={modality.modality}
              handleChangeModality={handleChangeModality}
              handleChangeHealer={handleChangeHealer}
              handleDeleteModality={handleDeleteModality}
            />
          )
        })
      }

      <Box
        display="flex"
        justifyContent="flex-end"
      >
        <Button
          variant="outlined"
          size="small"
          onClick={handleAddModality}
          startIcon={<Add />}
        >
          Add Modality
        </Button>
      </Box>
    </Paper>
  )
}

export default MainQuestionnaireOption;